// NOTE: When creating 'full' routes, we use an empty string as the first element in the array we are concatenating so we get a leading forward slash
const ErrorRoutes = {
  Error: ['', 'error'].join('/'),
  PageNotFound: ['', 'page-not-found'].join('/'),
  Unauthorized: ['', 'unauthorized'].join('/'),
};

export default ErrorRoutes;
